import type { InputSource } from '../types';

export const checkerboard: InputSource = {
  label: 'Checkerboard',
  value: 'checkerboard',
  draw: (ctx, width, height) => {
    ctx.clearRect(0, 0, width, height);

    const minDim = Math.min(width, height);
    const cellSize = Math.max(40, Math.round(minDim / 12));
    const light = '#ffffff';
    const dark = '#000000';

    for (let y = 0; y < height; y += cellSize) {
      for (let x = 0; x < width; x += cellSize) {
        const isDark = (x / cellSize + y / cellSize) % 2 === 0;
        ctx.fillStyle = isDark ? dark : light;
        ctx.fillRect(x, y, cellSize, cellSize);
      }
    }

    ctx.strokeStyle = 'rgba(30, 30, 30, 0.5)';
    ctx.lineWidth = Math.max(2, Math.round(minDim * 0.002));
    ctx.strokeRect(0, 0, width, height);
  },
};
